export enum Citizenship {
  Poland = 73
}
